(() => {
  const clean = value => value.replace(/\s+/g, ' ').trim();
  const metricText = text => text.replace(/\([^()]*\b(?:in|inches|oz)\b[^()]*\)/gi, '').replace(/\s+([.;])/g, '$1').replace(/\s{2,}/g, ' ').trim();
  const measured = text => /\d\s*(?:mm|cm|g)\b/i.test(text);
  const convert = (text, imperial) => metricText(text).replace(/(\d+(?:\.\d+)?(?:\s*[×x–-]\s*\d+(?:\.\d+)?)*)\s*(mm|cm|g)\b/gi, (_, values, unit) => {
    unit = unit.toLowerCase();
    const factor = unit === 'g' ? (imperial ? 1 / 28.349523125 : 1) : unit === 'mm' ? (imperial ? 1 / 25.4 : 0.1) : (imperial ? 1 / 2.54 : 1);
    return values.replace(/\d+(?:\.\d+)?/g, n => String(Number((Number(n) * factor).toFixed(2)))) + ' ' + (unit === 'g' ? (imperial ? 'oz' : 'g') : (imperial ? 'in' : 'cm'));
  });
  const patterns = [
    ['material', /^(?:materials?)\s*[·:]\s*(.+)$/i],
    ['finish', /^finish\s*[·:]\s*(.+)$/i],
    ['ear_posts', /^ear posts?\s*[·:]\s*(.+)$/i],
    ['product_code', /^sku\s*[·:]\s*(.+)$/i],
    ['care', /^care\s*[·:]\s*(.+)$/i],
    ['weight', /^((?:approximate\s+)?(?:product\s+|pair\s+)?weight(?:\s+per\s+pair)?)\s*[·:]\s*(.+)$/i],
    ['dimensions', /^(?:dimensions|size)\s*[·:]\s*(.+)$/i],
    ['inner_diameter', /^inner diameter( as measured)?\s*[·:]?\s*(\d.+)$/i],
    ['pendant_diameter', /^pendant diameter\s*[·:]?\s*(\d.+)$/i],
    ['pendant_height', /^pendant height\s*[·:]?\s*(\d.+)$/i],
    ['pendant_width', /^pendant width\s*[·:]?\s*(\d.+)$/i],
    ['chain_length', /^(?:chain length|necklace length|chain)\s*[·:]?\s*(\d.+)$/i],
    ['extension', /^(?:extension chain|extender|extension)\s*[·:]?\s*(.+)$/i],
    ['length', /^length\s*[·:]?\s*(\d.+)$/i],
    ['pendant', /^(?:flower pendant|pendant size|pendant)\s*[·:]?\s*(\d.+)$/i],
    ['post_length', /^post length\s*[·:]?\s*(\d.+)$/i],
    ['maximum_height', /^maximum height\s*[·:]?\s*(\d.+)$/i],
    ['maximum_width', /^widest point\s*[·:]?\s*(\d.+)$/i],
    ['minimum_width', /^narrowest point\s*[·:]?\s*(\d.+)$/i],
    ['height', /^(?:overall height|height)\s*[·:]?\s*(\d.+)$/i],
    ['width', /^width\s*[·:]?\s*(\d.+)$/i],
    ['diameter', /^(?:disc diameter|diameter)\s*[·:]?\s*(\d.+)$/i],
    ['left', /^left (?:style|height)\s*[·:]?\s*(\d.+)$/i],
    ['right', /^right (?:style|height)\s*[·:]?\s*(\d.+)$/i],
    ['long_earring', /^long earring\s*[·:]?\s*(\d.+)$/i],
    ['short_earring', /^short earring\s*[·:]?\s*(\d.+)$/i],
    ['design', /^design\s*[·:]\s*(.+)$/i]
  ];
  const dimensionOrder = ['chain_length','length','extension','dimensions','pendant','pendant_height','pendant_width','pendant_diameter','height','maximum_height','width','maximum_width','minimum_width','diameter','inner_diameter','left','right','long_earring','short_earring','post_length','weight'];
  const element = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  };
  const init = () => document.querySelectorAll('[data-ms-details]:not([data-details-ready])').forEach(root => {
    const labels = JSON.parse(root.querySelector('[data-ms-details-labels]').textContent);
    const description = root.querySelector('[data-ms-description]').content;
    const canonical = root.querySelector('[data-ms-canonical]');
    const values = new Map();
    const care = [];
    const add = (key, value) => {
      value = clean(value).replace(/[.;]$/, '');
      if (!value) return;
      const existing = values.get(key) || [];
      if (!existing.includes(value)) existing.push(value);
      values.set(key, existing);
    };
    const parse = raw => {
      const text = metricText(clean(raw));
      if (!text) return;
      for (const [key, pattern] of patterns) {
        const match = text.match(pattern);
        if (!match) continue;
        let value = match[1];
        if (key === 'care') { care.push(value); return; }
        if (key === 'weight') {
          value = match[2];
          if (/pair/i.test(match[1]) && !/pair/i.test(value)) value += ' per pair';
          if (/approximate/i.test(match[1]) && !/^approx/i.test(value)) value = 'Approx. ' + value;
        }
        if (key === 'inner_diameter') value = match[2] + (match[1] ? ' (as measured)' : '');
        if (key === 'dimensions') {
          if (/^(?:chain|height|right height|left height|pendant|width|maximum height)\b/i.test(value)) { parse(value); return; }
          add(key, value); return;
        }
        if (dimensionOrder.includes(key)) {
          const fragments = value.split(/\s*[;·]\s*/);
          if (fragments.length > 1) { parse(text.slice(0, text.indexOf(value)) + fragments.shift()); fragments.forEach(parse); return; }
          if (key === 'chain_length' || key === 'length') {
            const chain = value.match(/^(\d+(?:\.\d+)?\s*(?:cm|mm))\s*\+\s*(\d+(?:\.\d+)?\s*(?:cm|mm))\s*(?:extension|extender)(?: chain)?\.?$/i);
            if (chain) { add(key, chain[1]); add('extension', chain[2]); return; }
          }
        }
        add(key, value); return;
      }
      if (/^sold as (?:a pair|one piece)/i.test(text)) { add('quantity', text.replace(/^sold as /i, '')); return; }
      const fragments = text.split(/\s*[;·]\s*/);
      if (fragments.length > 1) { fragments.forEach(parse); return; }
      add('design', text);
    };
    const sourceRows = canonical ? canonical.querySelectorAll('p, li') : description.querySelectorAll('li');
    sourceRows.forEach(row => { if (!row.querySelector('p, li')) parse(row.textContent); });
    if (!values.has('material')) add('material', root.querySelector('[data-ms-material]').content.textContent);
    if (root.dataset.productType?.toLowerCase() === 'necklace' && values.has('length') && !values.has('chain_length')) {
      values.set('chain_length', values.get('length'));
      values.delete('length');
    }
    const intro = element('div', 'ms-details-intro');
    const styling = [];
    let section = 'intro';
    description.querySelectorAll('h2,h3,h4,p,ul,ol').forEach(node => {
      if (/^H[234]$/.test(node.tagName)) { section = /care/i.test(node.textContent) ? 'care' : /styl/i.test(node.textContent) ? 'styling' : 'specs'; return; }
      if (node.tagName === 'UL' || node.tagName === 'OL') { section = 'after'; return; }
      if (node.closest('li')) return;
      const text = clean(node.textContent);
      if (section === 'care' || /^(?:keep away from|wipe gently|store separately|avoid water)/i.test(text)) { if (!care.length) care.push(text); return; }
      if (section === 'styling') { styling.push(text); return; }
      if (text && section !== 'specs') intro.append(node.cloneNode(true));
    });
    const body = element('div', 'ms-details-body');
    if (intro.childNodes.length) body.append(intro);
    const conversionRows = [];
    const table = keys => {
      const dl = element('dl');
      keys.forEach(key => {
        if (!values.has(key)) return;
        const value = values.get(key).join('; ');
        const row = element('div', 'ms-details-row');
        const dd = element('dd', '', value);
        row.append(element('dt', '', labels[key] || key), dd);
        dl.append(row);
        if (measured(value) && dimensionOrder.includes(key)) conversionRows.push({el: dd, original: value});
      });
      return dl;
    };
    const materials = table(['material','finish','ear_posts','design']);
    if (materials.childNodes.length) body.append(materials);
    const measurements = table(dimensionOrder);
    if (measurements.childNodes.length) {
      const group = element('div', 'ms-details-measurements');
      const head = element('div', 'ms-details-section-head');
      head.append(element('h3', '', labels.size_weight));
      if (conversionRows.length) {
        const units = element('div', 'ms-details-units');
        units.setAttribute('role', 'group'); units.setAttribute('aria-label', labels.units);
        ['metric','imperial'].forEach(unit => {
          const button = element('button', '', labels[unit]);
          button.type = 'button'; button.dataset.unit = unit; button.setAttribute('aria-pressed', String(unit === 'metric'));
          units.append(button);
        });
        const setUnit = unit => {
          conversionRows.forEach(row => { row.el.textContent = convert(row.original, unit === 'imperial'); });
          units.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
        };
        units.addEventListener('click', event => { const button = event.target.closest('button[data-unit]'); if (button) setUnit(button.dataset.unit); });
        setUnit('metric'); head.append(units);
      }
      group.append(head, measurements); body.append(group);
    }
    const secondary = element('div', 'ms-details-secondary');
    if (values.has('quantity')) secondary.append(table(['quantity']));
    styling.forEach(text => secondary.append(element('p', 'ms-details-styling', text)));
    if (secondary.childNodes.length) body.append(secondary);
    if (values.has('product_code')) body.append(element('p', 'ms-details-code', labels.product_code + ' ' + values.get('product_code').join('; ')));
    const carePanel = root.nextElementSibling;
    if (carePanel?.matches('[data-ms-details-care]')) {
      const careBody = carePanel.querySelector('[data-ms-care-body]');
      if (care.length) careBody.replaceChildren(...[...new Set(care)].map(text => element('p', '', text)));
      if (!clean(careBody.textContent)) carePanel.hidden = true;
    }
    root.querySelector('[data-ms-details-body]').replaceWith(body);
    root.dataset.detailsReady = 'true';
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
